import { atom, useAtom, useSetAtom } from "jotai";

type modals =
  | ""
  | "ordersMapModal"
  | "zipcodeMapModal"
  | "activity"
  | "loginAsCustomer"
  | "order"
  | "map"
  | "mapOrdersMap"
  | "table"
  | "productReviews"
  | "qr"
  | "orderProducts"
  | "findMyZipcodes"
  | "reviewGeneratorSelection"
  | "systemTracker"
  | "qrPrint"
  | "allergenPoster"
  | "printReceipt"
  | "menuFastExtras"
  | "menuProduct"
  | "menuCategory"
  | "menuConfirmation"
  | "menuGarnish"
  | "menuTopping"
  | "menuFastGarnish"
  | "menuFastAllergen"
  | "menuFastLabel"
  | "menuFastVats"
  | "menuRecommendedProduct"
  | "menuDescriptions"
  | "menuScanBarcode"
  | "menuProductImage"
  | "aboutUsImage"
  | "courierPrivacy"
  | "mapSettings"
  | "mapOrdersSettings"
  | "mapOrdersSelect"
  | "courierQrLogin"
  | "scheduleDeposit"
  | "colorTemplate"
  | "deliverOverview"
  | "deposit"
  | "screen"
  | "changeOfflinePayment"
  | "orderUser"
  | "refund"
  | "replyViaEmail"
  | "printSessionReceipt"
  | "posOrderDiscount"
  | "internalNotificationReply"
  | "internalNotificationDelete"
  | "posOrderRemark"
  | "posOrderProduct"
  | "posOrderDiscountCode"
  | "posOrderResetCart"
  | "posOrderChangeLabel"
  | "posTable"
  | "qrSettings"
  | "tableOrders"
  | "schedulesPrint"
  | "scheduleRoster"
  | "onboardingCreate"
  | "posOrderSelectToppings"
  | "termsAndConditions"
  | "themeDeleteConfirmation"
  | "copyToppings"
  | "themeClone"
  | "reorderFlyer"
  | "addUrl"
  | "splitPayment"
  | "changeTables"
  | "mergeSessions"
  | "kioskLanguages"
  | "customerOrderHistory"
  | "kioskCheckout"
  | "kioskCartItemNote"
  | "pickupScreenSettings"
  | "financialReportReceiptSettings"
  | "cartItemNote"
  | "personnelCheckIn"
  | "assignCourier"
  | "posOrderPendingPaymentDecision"
  | "branchSelect"
  | "posCartPayment"
  | "posDeliveryMethod";

interface Modal {
  meta: any;
  type: modals;
}
export const modalAtom = atom<Modal>({
  meta: {},
  type: "",
});

export const modalMetaAtom = atom((get) => get(modalAtom).meta);

export const useModalMeta = () => {
  const atom = useAtom(modalMetaAtom);
  return atom;
};

const useModal = () => {
  const atom = useAtom(modalAtom);
  return atom;
};

export const useSetModal = () => {
  const set = useSetAtom(modalAtom);
  return (type: modals, meta = {}) =>
    set({
      type,
      meta,
    });
};

export default useModal;
